var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaneuropeanUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "M0 24h30V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m14.22 5.08.3-.92-.79-.57h.97l.3-.92.3.92h.97l-.79.57.3.92L15 4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m15 18.67-.3.92h-.97l.79.57-.3.92.78-.57.78.57-.3-.92.79-.57h-.97z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m7 10.67-.3.92h-.97l.79.57-.3.92.78-.57.78.57-.3-.92.79-.57H7.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m10.22 6.15.78-.57.78.57-.3-.92.79-.57h-.97l-.3-.92-.3.92h-.97l.79.57z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m8.86 9.08-.3-.92.78-.57h-.97l-.3-.92-.3.92H6.8l.79.57-.3.92.78-.57z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M9.34 15.59h-.97l-.3-.92-.3.92H6.8l.79.57-.3.92.78-.57.79.57-.3-.92z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M12.27 18.52h-.97l-.3-.93-.3.93h-.97l.79.57-.3.92.78-.57.78.57-.3-.92z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m23 10.67.3.92h.97l-.79.57.3.92-.78-.57-.78.57.3-.92-.79-.57h.97z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M19.78 6.15 19 5.58l-.78.57.3-.92-.79-.57h.97l.3-.92.3.92h.97l-.79.57z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m21.14 9.08.3-.92-.78-.57h.97l.3-.92.3.92h.97l-.79.57.3.92-.78-.57z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M20.66 15.59h.97l.3-.92.3.92h.97l-.79.57.3.92-.78-.57-.79.57.3-.92z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M17.73 18.52h.97l.3-.93.3.93h.97l-.79.57.3.92-.78-.57-.78.57.3-.92z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd00",
    d: "M20.89 12.02a5.96 5.96 0 1 1-11.91 0 5.96 5.96 0 0 1 11.91 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80000",
    d: "M14 17.9V13H9.06A6 6 0 0 0 14 17.9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80000",
    d: "M16 17.88A6 6 0 0 0 20.8 13H16z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80000",
    d: "M20.8 11A6 6 0 0 0 16 6.16V11z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80000",
    d: "M14 6.14A6 6 0 0 0 9.07 11H14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaneuropeanUnion);
export default __webpack_public_path__ + "static/media/paneuropean-union.62f31ba9a55feb1e42642a2d490250a9.svg";
export { ForwardRef as ReactComponent };